import {CSSProperties, FC} from 'react';


export interface IIconTransmissionAProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTransmissionA: FC<IIconTransmissionAProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M18.004 4.965h.699c.712 0 1.291.58 1.291 1.291v.377c0 .712-.58 1.291-1.291 1.291h-.699a1.41 1.41 0 0 1-1.361 1.048h-.575v11.179c0 1.02-.83 1.849-1.85 1.849h-1.417c-1.02 0-1.85-.83-1.85-1.85V8.973h-.575a1.409 1.409 0 0 1-1.407-1.407v-2.24c0-.776.63-1.408 1.407-1.408h.576V3.85C10.952 2.83 11.78 2 12.8 2h1.417c1.02 0 1.85.83 1.85 1.85v.067h.575a1.41 1.41 0 0 1 1.361 1.048Zm-7.803 2.6c0 .096.079.174.175.174h3.592V5.15h-3.592a.175.175 0 0 0-.175.175v2.24Zm4.017 13.202c.34 0 .617-.276.617-.616V8.972h-2.65v11.179c0 .34.276.616.616.616h1.417Zm.366-16.85h.25V3.85a.617.617 0 0 0-.616-.616h-1.417a.617.617 0 0 0-.616.616v.068h2.4Zm2.059 3.822a.175.175 0 0 0 .175-.174v-2.24a.175.175 0 0 0-.175-.175H15.2v2.59h1.443Zm2.06-1.048a.059.059 0 0 0 .058-.058v-.377a.058.058 0 0 0-.058-.058h-.653v.493h.653ZM5.555 4.116h1.13a1.37 1.37 0 0 1 1.368 1.369 1.37 1.37 0 0 1-1.369 1.368H6.11v.53a.555.555 0 1 1-1.11 0V4.671c0-.306.248-.555.555-.555Zm.555 1.628h.574a.26.26 0 0 0 0-.518H6.11v.518Zm1.388 7.23a.555.555 0 0 0-.555.554v.985l-.937-1.308C5.693 12.768 5 12.99 5 13.528v2.712a.555.555 0 1 0 1.11 0v-.985l.937 1.308c.313.438 1.006.217 1.006-.323v-2.712a.555.555 0 0 0-.555-.555ZM5.555 17.4h1.114c.763 0 1.384.62 1.384 1.384v1.054c0 .763-.621 1.384-1.384 1.384H5.555A.555.555 0 0 1 5 20.668v-2.712c0-.307.248-.555.555-.555Zm1.114 2.712a.275.275 0 0 0 .274-.274v-1.054a.275.275 0 0 0-.274-.274h-.56v1.602h.56Zm.015-11.568h-1.13A.555.555 0 0 0 5 9.1v2.712a.555.555 0 1 0 1.11 0v-.53h.168l.806.9a.555.555 0 1 0 .827-.74L7.515 11a1.367 1.367 0 0 0-.83-2.455Zm0 1.627H6.11v-.517h.574a.26.26 0 0 1 0 .517ZM9.725 11.2h-.39a.473.473 0 0 1 0-.945h.39a.473.473 0 0 1 0 .945Zm0 4.219a.472.472 0 1 0 0-.946h-.39a.473.473 0 1 0 0 .946h.39Zm-.25 3.366h.39a.473.473 0 0 1 0 .946h-.39a.473.473 0 1 1 0-.946Z" clipRule="evenodd" />
        </svg>
    );
};
